var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assessment"},[_c('div',{staticClass:"list-group"},[(_vm.enableAI)?_c('AIAnalysis',{attrs:{"physician_id":_vm.physician_id,"hcp-data":_vm.hcpData}}):_vm._e(),_c('div',{staticClass:"list-group-item",staticStyle:{"margin-top":"15px"}},[_c('section',[_c('relationship')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }